import { useCallback, useState } from 'react';
import type { VoidFunctionComponent } from 'react';
import * as _ from 'lodash';
import Select from 'react-select-2';
import type { ValueType } from 'react-select-2/lib/types';

import { selectOptionFactory } from '../../../utils';
import { InlineLoaderButton } from '../../generic/Button';
import { useDialogContext } from '../../../contexts/DialogContext';
import { post } from '../../../redux/api';
import Flex from '../../generic/Flex';
import useAsyncStatus from '../../../hooks/useAsyncStatus';
import type { FailedFetchResponse } from '../../../helpers/errors';

type EnrichMetadataComponentProps = {
  type: 'project' | 'revision';
  supportedFetchers: string[];
};

const EnrichMetadataComponent: VoidFunctionComponent<EnrichMetadataComponentProps> = ({ type, supportedFetchers }) => {
  const { onConfirm } = useDialogContext();
  const [fetcher, setFetcher] = useState<string>('npm');
  const { status, onPending, onSuccess, onError } = useAsyncStatus();

  const submitEnrichment = useCallback(async () => {
    onPending();
    try {
      await post(`/api/risk/enrich/${type}`, { fetcher });
      onSuccess();
    } catch (err) {
      onError(err as FailedFetchResponse);
    }
  }, [fetcher, type, onPending, onSuccess, onError]);

  return (
    <div className="card">
      <h3 className="card-title padding-bottom-sm">Enrich {_.capitalize(type)} Metadata</h3>
      <Flex justify="left" gap={10}>
        <div className="width-quarter">
          <Select
            value={selectOptionFactory(fetcher)}
            options={supportedFetchers.map((f) => selectOptionFactory(f))}
            onChange={(option: ValueType<{ value: string; label: string }>) => {
              setFetcher(option?.value);
            }}
            />
        </div>
        <InlineLoaderButton
          onClick={() => {
            onConfirm({
              title: 'Are you sure?',
              body: 'Metadata enrichment is a long running job that should not be done lightly. Are you sure you want to continue?',
              onConfirm: submitEnrichment,
            });
          }}
          isLoading={status.loading}
          isDisabled={status.loading}
          >
          Submit
        </InlineLoaderButton>
      </Flex>
    </div>
  );
};

export default EnrichMetadataComponent;
